import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  DisplayActions,
  PlayControlPlayer,
  ProgressBar,
  viPlayCircleOutline,
  VibeTooltip,
  VibeIcon,
  viDownload,
  color,
  withRouter,
} from 'vibeguide';
import userBubbleImage from '../../../../../assets/user-bubble.png';
import './HistoryMediaItem.scss';

class HistoryMediaItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentPercent: 0,
    };
  }

  /**
   * Open the display player with the history media item
   */
  showDisplayPlayer = () => {
    const {
      item,
      setDisplay,
    } = this.props;

    const historyMessage = [{
      _id: '1',
      name: 'Final Cut',
      media: [item],
    }];

    setDisplay({
      show: true,
      messages: historyMessage,
      isLoop: true,
    });
  };

  /**
   * When the time is updated
   */
  onTimeUpdate = (data) => {
    const {
      currentPercent,
    } = data;

    this.setState({
      currentPercent,
    });
  };

  /**
   * When clicking the download icon
   */
  onClickDownload = () => {
    const {
      url,
    } = this.props;

    window.open(url);
  };

  render() {
    const {
      type,
      date,
      item,
      url,
      username,
      imageUrl,
      last,
    } = this.props;

    const {
      currentPercent,
    } = this.state;

    const time = new moment(date).format('HH:mm');
    const image = imageUrl || userBubbleImage;

    let typeFormatted = type;

    if (type === 'rough') {
      typeFormatted = 'Rough Cut';
    } else if (type === 'final') {
      typeFormatted = 'Final Cut';
    }

    return (
      <div className="HistoryMediaItem">
        <div className="item-container">
          <div className="item">
            {item.contentType.includes('video') ? (
              <VibeIcon
                icon={viPlayCircleOutline}
                color={color.teal}
                hoverColor={color.teal}
                size={16}
                tooltip="Preview Visual"
                tooltipProps={{
                  placement: 'top',
                }}
                onClick={this.showDisplayPlayer}
              />
            ) : (
              <PlayControlPlayer
                className="left-icon"
                url={url}
                color={color.success}
                size={24}
                onTimeUpdate={this.onTimeUpdate}
              />
            )}

            <VibeIcon
              className="download-icon"
              icon={viDownload}
              color={color.manatee}
              hoverColor={color.obsidian}
              size={24}
              tooltip="Download"
              onClick={this.onClickDownload}
            />

            <div className="type-container">
              <div className="type">
                {typeFormatted}
              </div>
            </div>

            <div className="time">
              {time}
            </div>

            <div className="avatar-container">
              <VibeTooltip
                title={username}
                placement="left"
              >
                <img
                  className="avatar"
                  src={image}
                  alt="avatar"
                />
              </VibeTooltip>
            </div>
          </div>

          <ProgressBar
            className="play-progress"
            progress={currentPercent}
            color={color.success}
            height={4}
          />
        </div>

        {!last ? (
          <div className="item-connector" />
        ) : null}
      </div>
    );
  }
}

HistoryMediaItem.propTypes = {
  type: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  username: PropTypes.string,
  imageUrl: PropTypes.string,
  /** Last item in the history */
  last: PropTypes.bool,
};

HistoryMediaItem.defaultProps = {
  username: null,
  imageUrl: null,
  last: false,
};

const mapDispatchToProps = {
  setDisplay: DisplayActions.setDisplay,
};

export default withRouter(connect(null, mapDispatchToProps)(HistoryMediaItem));
